var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.1344C17.3848 21.1344 21.75 16.907 21.75 11.6922C21.75 6.47741 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.47741 2.25 11.6922C2.25 14.5284 3.54126 17.0725 5.58553 18.8034V20.7141C5.58553 21.4609 6.3462 21.9618 7.02441 21.6616L9.14474 20.723C10.0478 20.9905 11.0065 21.1344 12 21.1344Z",
    fill: "url(#paint0_linear_7053_108733)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66525 9.68499L6.83793 13.5517C6.53478 13.9663 7.07995 14.4644 7.495 14.152L9.90921 12.3352C10.1549 12.1502 10.4994 12.1477 10.748 12.3291L12.8951 13.8954C13.3069 14.1958 13.8954 14.1094 14.1952 13.7046L17.1604 9.70055C17.4679 9.2853 16.9185 8.78321 16.5029 9.09963L13.9505 11.0427C13.7047 11.2298 13.3584 11.2332 13.1086 11.0511L10.9685 9.48983C10.555 9.18819 9.96377 9.27673 9.66525 9.68499Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7053_108733",
    x1: 12,
    y1: 2.25,
    x2: 8.87147,
    y2: 21.6437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.4345e5f19d79cc819dd99a17905c90ca.svg";
export { ForwardRef as ReactComponent };